import { FC, useEffect, useLayoutEffect, useState } from "react";
import Menus from "../../dtos/Menus.dto";
import Footer from "../Footer/Footer";
import Header from "../Header";
import { DeviceTypes } from "../../constants/deviceTypes";
import FooterDefinition from "../../dtos/Footer.dto";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { setLocation } from "../../redux/location/location.actions";
import { RootState } from "../../redux/store";
import { setLoggedInUser } from "../../redux/loggedInUser/loggedInUser.actions";
import MainWrapper from "./MainWrapper";

interface MainLayoutProps {
  menus: Menus;
  headerBgColorBack?:
    | "primary"
    | "secondary"
    | "darkBlue"
    | "skyBlue"
    | "white"
    | "lightSkyBlue";
  children: React.ReactNode;
  isHome?: boolean;
  footer: FooterDefinition;
}

const MainLayout: FC<MainLayoutProps> = ({
  menus,
  headerBgColorBack,
  isHome,
  children,
  footer,
}) => {
  const [device, setDevice] = useState(DeviceTypes.DESKTOP);
  const [widthSize, setWidthSize] = useState<number | null>(null);
  const showLoader = useSelector((state: RootState) => state.loader);

  useLayoutEffect(() => {
    const handleResize = () => {
      setDevice(
        window.innerWidth < 768 ? DeviceTypes.MOBILE : DeviceTypes.DESKTOP
      );
      setWidthSize(window.innerWidth);
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(function () {
    const userData = localStorage.getItem("ezyLegalUserData");
    if (userData === null) {
      dispatch(setLoggedInUser(null));
    }
  }, []);

  const dispatch = useDispatch();

  return (
    // <LoadingOverlay active={showLoader.showLoader} spinner text={'Please wait'}>
    //   <div
    //     className="d-flex flex-column justify-content-between"
    //     style={{
    //       minHeight: '100vh',
    //     }}
    //   >
    <>
      <Header
        headerMenu={menus?.header || []}
        bgColorBack={headerBgColorBack || "white"}
        device={device}
        widthSize={widthSize}
      />
      <MainWrapper>{children}</MainWrapper>
      <Footer
        footer1Menu={menus?.footer1 || []}
        isHome={isHome}
        device={device}
        footer={footer}
      />
    </>
    // </LoadingOverlay>
  );
};

export default MainLayout;
